import React from "react";
import { Icon } from "@iconify/react";

const BenchMarkAnalyseComponent = () => {
    return (
        <div className="md:h-screen flex items-center w-11/12">
            <div>
                <h2 className="text-[#036F36] text-lg md:text-xl lg:text-3xl mb-3">
                    Benchmarking and Analytics
                </h2>
                <p className="text-lg md:text-xl lg:text-2xl">
                    Stay ahead with in-depth insights on policy coverage, implementation, and effectiveness. Our benchmarking tool evaluates policies across agri-food systems and countries, providing a clear, data-driven score to track performance and guide improvements.
                </p>
                <a href="/home-benchmarking">
                    <button className="common-button mt-3 ml-0 text-base md:text-lg lg:text-xl">
                        Evaluate Policy Adequacy
                        <Icon icon="maki:arrow" width="12" height="12" className="ml-2"/>
                    </button>
                </a>
            </div>
        </div>
    );
};

export default BenchMarkAnalyseComponent;